import fetch from './fetch'
import { urlPerfix } from '@/config/env'

// 获取验证码
export const mobileCode = phone => fetch(urlPerfix + '/verify_code', {
	token_validate: false,
	phone_number: phone,
}, 'GET');
// 登录
export const loginVerification = (mobile, captcha, password = '') => fetch(urlPerfix + '/login', {
	token_validate: false,
	mobile: mobile,
	captcha: captcha,
	password: password,
}, 'POST');

// 获取验证码信息
export const getCaptcha = () => fetch(urlPerfix + '/captcha', {
	token_validate: false
}, "GET")

export const passwordLogin = data => fetch(urlPerfix + '/password_login', data, 'POST');

export const getOssSignData = data => fetch(urlPerfix + '/oss', data);
export const fileExport = data => fetch(urlPerfix + '/files/export', data)


export const getFunctionModules = (user = false) => fetch(urlPerfix + '/function_modules', {
	user: user
})
export const functionModuleUpdate = data => fetch(urlPerfix + '/function_modules/' + data.id, data, 'PUT')

// users
export const getUserFunctionModules = () => fetch(urlPerfix + '/users/function_modules')
export const userList = data => fetch(urlPerfix + '/users', data)
export const userNew = data => fetch(urlPerfix + '/users', data, 'POST')
export const userInfo = id => fetch(urlPerfix + '/users/show/' + id)
export const userUpdate = data => fetch(urlPerfix + '/users/' + data.id, data, "PUT")
export const userUpdateStatus = data => fetch(urlPerfix + '/users/status', data, 'POST')
export const userUpdateProfile = data => fetch(urlPerfix + '/users/profile', data, 'POST')
export const userDelete = id => fetch(urlPerfix + '/users/' + id, {}, 'DELETE')
export const resetUserPassword = data => fetch(urlPerfix + `/users/password`, data, 'POST')


// roles
export const roleList = data => fetch(urlPerfix + '/roles')
export const roleNew = data => fetch(urlPerfix + '/roles', data, 'POST')
export const roleUpdate = data => fetch(urlPerfix + '/roles/' + data.id, data, 'PUT')

//authority
export const authList = () => fetch(urlPerfix + '/authorities')
export const roleAuthList = data => fetch(urlPerfix + '/role_authorities', data)
export const roleAuthUpdate = data => fetch(urlPerfix + '/role_authorities', data, 'POST')

// orders
export const notificationList = data => fetch(urlPerfix + '/users/notifications', data)

export const orderList = data => fetch(urlPerfix + '/orders', data)
export const orderNew = data => fetch(urlPerfix + '/orders', data, 'POST')
export const orderInfoBySerialNumber = number => fetch(urlPerfix + '/orders/' + number + '/info', {}, 'POST')
export const orderShow = id => fetch(urlPerfix + '/orders/' + id)
export const orderUpdate = data => fetch(urlPerfix + '/orders/' + data.id, data, 'PUT')
export const orderUpdateOptionStatus = data => fetch(urlPerfix + '/orders/' + data.id + '/option_status', data, 'POST')
export const orderDelete = id => fetch(urlPerfix + '/orders/' + id, {}, 'DELETE')

export const orderUserList = () => fetch(urlPerfix + '/orders/users')

export const orderLaunch = data => fetch(urlPerfix + '/orders/' + data.id + '/launch', data, 'POST')
export const orderCheck = data => fetch(urlPerfix + '/orders/' + data.id + '/check', data, 'POST')
export const orderChiefCheck = data => fetch(urlPerfix + '/orders/' + data.id + '/chief_check', data, 'POST')
export const orderApprove = data => fetch(urlPerfix + '/orders/' + data.id + '/approve', data, 'POST')
export const orderFactory = data => fetch(urlPerfix + '/orders/' + data.id + '/factory', data, 'POST')
export const orderDrillReceive = data => fetch(urlPerfix + '/orders/' + data.id + '/receive', data, 'POST')
export const orderModelSendCheck = data => fetch(urlPerfix + '/orders/' + data.id + '/model_send', data, 'POST')
export const orderAddInvoice = data => fetch(urlPerfix + '/orders/' + data.id + '/invoice', data, 'POST')

export const factoryList = data => fetch(urlPerfix + '/factories', data)
export const factoryNew = data => fetch(urlPerfix + '/factories', data, 'POST')
export const factoryShow = id => fetch(urlPerfix + '/factories/' + id)
export const factoryUpdate = data => fetch(urlPerfix + '/factories/' + data.id, data, 'PUT')

export const fixBaseList = data => fetch(urlPerfix + '/fix_bases', data)

// export const repairOrderList = data => fetch(urlPerfix + '/repair_orders', data)
// export const repairOrderNew = data => fetch(urlPerfix + '/repair_orders', data, "POST")
// export const repairOrderUpdate = data => fetch(urlPerfix + '/repair_orders/' + data.id, data, "PUT")
// export const repairOrderDetail = id => fetch(urlPerfix + '/repair_orders/' + id)
// export const repairOrderDelete = id => fetch(urlPerfix + '/repair_orders/' + id, {}, "DELETE")
// export const repairOrderUpdateStatus = id => fetch(urlPerfix + '/repair_orders/' + id + '/status', {}, "POST")
// export const repairOrderUpdateItem = data => fetch(urlPerfix + '/repair_orders/' + data.id + '/item', data, "POST")

export const formParamList = data => fetch(urlPerfix + '/form_params', data)
export const formParamCreate = data => fetch(urlPerfix + '/form_params', data, 'POST')
// export const formParamUpdate = data => fetch(urlPerfix + '/form_params/' + data.id, data, 'PUT')
export const formParamDelete = id => fetch(urlPerfix + '/form_params/' + id, {}, 'DELETE')

export const orderFlowSetList = () => fetch(urlPerfix + '/order_flow_sets')
export const orderFlowSetUpdate = data => fetch(urlPerfix + '/order_flow_sets', data, 'POST')

export const itemList = data => fetch(urlPerfix + '/items', data)
export const itemNew = data => fetch(urlPerfix + '/items', data, 'POST')
export const itemDetail = id => fetch(urlPerfix + '/items/' + id)
export const itemUpdate = data => fetch(urlPerfix + '/items/' + data.id, data, 'PUT')
export const itemDelete = id => fetch(urlPerfix + '/items/' + id, {}, 'DELETE')
export const itemSettleStock = () => fetch(urlPerfix + '/items/settle_stock', {}, 'POST')

export const itemInRecordList = data => fetch(urlPerfix + '/item_in_records', data)
export const itemInRecordNew = data => fetch(urlPerfix + '/item_in_records', data, 'POST')
export const itemInRecordUpdate = data => fetch(urlPerfix + '/item_in_records/' + data.id, data, 'PUT')
export const itemInRecordDelete = id => fetch(urlPerfix + '/item_in_records/' + id, {}, 'DELETE')
export const itemInRecordConfirm = id => fetch(urlPerfix + '/item_in_records/' + id + '/confirm', {}, 'POST')

export const itemOutRecordList = data => fetch(urlPerfix + '/item_out_records', data)
export const itemOutRecordListDetail = data => fetch(urlPerfix + '/item_out_record_lists', data)
export const itemOutRecordNew = data => fetch(urlPerfix + '/item_out_records', data, 'POST')
export const itemOutRecordUpdate = data => fetch(urlPerfix + '/item_out_records/' + data.id, data, 'PUT')
export const itemOutRecordDelete = id => fetch(urlPerfix + '/item_out_records/' + id, {}, 'DELETE')
export const itemOutRecordConfirm = id => fetch(urlPerfix + '/item_out_records/' + id + '/confirm', {}, 'POST')
export const itemOutRecordDetail = id => fetch(urlPerfix + '/item_out_records/' + id)

export const drillList = data => fetch(urlPerfix + '/drills', data)
// export const drillNew = data => fetch(urlPerfix + '/drills', data, 'POST')
export const drillDetail = id => fetch(urlPerfix + '/drills/' + id)
// export const drillUpdate = data => fetch(urlPerfix + '/drills/' + data.id, data, 'PUT')
// export const drillDelete = id => fetch(urlPerfix + '/drills/' + id, {}, 'DELETE')
// export const drillStockInConfirm = id => fetch(urlPerfix + '/drills/' + id + '/confirm', {}, 'POST')
// export const drillStockOut = data => fetch(urlPerfix + '/drills/' + data.id + '/stock_out', data, 'POST')

// 钻头出入库
export const drillRecordList = data => fetch(urlPerfix + '/drill_records', data)
export const drillRecordNew = data => fetch(urlPerfix + '/drill_records', data, 'POST')
export const drillRecordUpdate = data => fetch(urlPerfix + '/drill_records/' + data.id, data, 'PUT')
export const drillRecordDelete = id => fetch(urlPerfix + '/drill_records/' + id, {}, 'DELETE')
export const drillRecordConfirm = data => fetch(urlPerfix + '/drill_records/' + 'confirm/' + data.id, data, 'POST')
export const drillRecordStockOut = data => fetch(urlPerfix + '/drill_records/' + 'stock_out/' + data.id, data, 'POST')
export const drillRecordBatchStockOut = data => fetch(urlPerfix + '/drill_records/batch_stock_out', data, 'POST')

// 发货
export const deliveryCreate = data => fetch(urlPerfix + '/deliveries', data, 'POST')
export const deliveryUpdate = data => fetch(urlPerfix + '/deliveries/', data.id, 'PUT')
export const deliveryDetail = data => fetch(urlPerfix + '/deliveries/' + data.id)
export const deliveryDetailBySubject = data => fetch(urlPerfix + '/deliveries/subject', data)

export const logisticDetail = data => fetch(urlPerfix + '/express', data, 'POST')
export const getShippers = () => fetch(urlPerfix + '/express/shippers')

// 复合片库存
export const pdcList = data => fetch(urlPerfix + '/pdcs', data)
export const pdcNew = data => fetch(urlPerfix + '/pdcs', data, 'POST')
export const pdcUpdate = data => fetch(urlPerfix + '/pdcs/' + data.id, data, 'PUT')
export const pdcDetail = id => fetch(urlPerfix + '/pdcs/' + id)
export const pdcDelete = id => fetch(urlPerfix + '/pdcs/' + id, {}, 'DELETE')

// 复合片入库
export const pdcInRecordList = data => fetch(urlPerfix + '/pdc_in_records', data)
export const pdcInRecordNew = data => fetch(urlPerfix + '/pdc_in_records', data, 'POST')
export const pdcInRecordUpdate = data => fetch(urlPerfix + '/pdc_in_records/' + data.id, data, 'PUT')
export const pdcInRecordDelete = id => fetch(urlPerfix + '/pdc_in_records/' + id, {}, 'DELETE')
export const pdcInRecordConfirm = id => fetch(urlPerfix + '/pdc_in_records/' + id + '/confirm', {}, 'POST')

// 复合片出库
export const pdcOutRecordList = data => fetch(urlPerfix + '/pdc_out_records', data)
export const pdcOutRecordListDetail = data => fetch(urlPerfix + '/pdc_out_record_lists', data)
export const pdcOutRecordNew = data => fetch(urlPerfix + '/pdc_out_records', data, 'POST')
export const pdcOutRecordUpdate = data => fetch(urlPerfix + '/pdc_out_records/' + data.id, data, 'PUT')
export const pdcOutRecordDelete = id => fetch(urlPerfix + '/pdc_out_records/' + id, {}, 'DELETE')
export const pdcOutRecordConfirm = id => fetch(urlPerfix + '/pdc_out_records/' + id + '/confirm', {}, 'POST')
export const pdcOutRecordDetail = id => fetch(urlPerfix + '/pdc_out_records/' + id)

//出库单
export const outboundOrderList = data => fetch(urlPerfix + '/outbound_orders', data)
export const outboundOrderNew = data => fetch(urlPerfix + '/outbound_orders', data, "POST")
export const outboundOrderUpdate = data => fetch(urlPerfix + '/outbound_orders/' + data.id, data, "PUT")
export const outboundOrderDetail = id => fetch(urlPerfix + '/outbound_orders/' + id)
export const outboundOrderDelete = id => fetch(urlPerfix + '/outbound_orders/' + id, {}, "DELETE")
export const outboundOrderConfirm = data => fetch(urlPerfix + '/outbound_orders/' + data.id + '/confirm', data, "POST")

// 零件盘点
export const itemInventoryList = data => fetch(urlPerfix + '/item_inventories', data)
export const itemInventoryRecord = data => fetch(urlPerfix + '/item_inventories/query', data)
export const itemInventoryUpdate = data => fetch(urlPerfix + '/item_inventories', data, 'POST')

// 复合片盘点
export const pdcInventoryList = data => fetch(urlPerfix + '/pdc_inventories', data)
export const pdcInventoryRecord = data => fetch(urlPerfix + '/pdc_inventories/query', data)
export const pdcInventoryUpdate = data => fetch(urlPerfix + '/pdc_inventories', data, 'POST')

// 仓库设置
export const stockroomList = data => fetch(urlPerfix + '/stockrooms', data)
export const updateUserCurrentStockroom = data => fetch(urlPerfix + '/users/current_stockroom_id', data, "POST")
export const stockroomCreate = data => fetch(urlPerfix + '/stockrooms', data, 'POST')
export const stockroomUpdate = data => fetch(urlPerfix + '/stockrooms/' + data.id, data, 'PUT')

// 钻头信息汇总页接口
export const drillBaseInfo = serial_number => fetch(urlPerfix + '/drills/' + serial_number + '/drill_info', {}, "POST")
export const drillOrderInfo = serial_number => fetch(urlPerfix + '/drills/' + serial_number + '/order_info', {}, "POST")
export const drillProduceInfo = serial_number => fetch(urlPerfix + '/drills/' + serial_number + '/produce_info', {}, "POST")
export const drillProjectInfo = serial_number => fetch(urlPerfix + '/drills/' + serial_number + '/project_info', {}, "POST")
export const drillStockInfo = serial_number => fetch(urlPerfix + '/drills/' + serial_number + '/stock_info', {}, "POST")
export const drillPdcInfo = serial_number => fetch(urlPerfix + '/drills/' + serial_number + '/pdc_info', {}, "POST")
export const drillConfirmCost = serial_number => fetch(urlPerfix + '/drills/' + serial_number + '/confirm_cost', {}, "POST")
export const drillCostNew = data => fetch(urlPerfix + '/drills/' + data.serial_number + '/new_cost', data, "POST")
export const drillCostDelete = data => fetch(urlPerfix + '/drills/' + data.serial_number + '/delete_cost', data, "POST")

export const drillCostStatistic = data => fetch(urlPerfix + '/statistics/drill_cost', data)

// 生产
export const getTaskUsers = () => fetch(urlPerfix + '/account/task_users', {}, 'GET')
export const getInspectors = () => fetch(urlPerfix + '/account/inspectors', {}, 'GET')
export const roles = data => fetch(urlPerfix + '/account/roles', data, 'GET')

export const flowTemplates = data => fetch(urlPerfix + '/flow/templates', data, 'GET')
export const briefFlowTemplates = data => fetch(urlPerfix + '/flow/brief_templates', data, 'GET')
export const newFlowTemplate = data => fetch(urlPerfix + '/flow/templates', data, 'POST')
export const updateFlowTemplate = data => fetch(urlPerfix + '/flow/templates', data, 'PUT')
export const deleteFlowTemplate = data => fetch(urlPerfix + '/flow/templates/' + data.flowId, {}, 'DELETE')
export const flowTemplateDetail = data => fetch(urlPerfix + '/flow/templates/' + data.flowId, {}, 'GET')
export const newFlowNode = data => fetch(urlPerfix + '/flow/nodes', data, 'POST')
export const delFlowNode = data => fetch(urlPerfix + '/flow/nodes/' + data.id, {}, 'DELETE')
export const flowNodeDetail = data => fetch(urlPerfix + '/flow/nodes/' + data.id, {}, 'GET')
export const updateFlowNode = data => fetch(urlPerfix + '/flow/nodes', data, 'PUT')
export const targetProducts = data => fetch(urlPerfix + '/products', {}, 'GET')
export const flows = () => fetch(urlPerfix + '/flow/flows', {}, 'GET')
export const newFlow = data => fetch(urlPerfix + '/flow/flows', data, 'POST')
export const startFlow = data => fetch(urlPerfix + '/flow/start', data, 'POST')
export const closeFlow = data => fetch(urlPerfix + '/flow/close', data, 'POST')
export const cancelFlow = data => fetch(urlPerfix + '/flow/cancel', data, 'POST')
export const pauseOrStartFlow = data => fetch(urlPerfix + '/flow/pause_or_start', data, 'POST')
export const flowHistories = data => fetch(urlPerfix + '/flow/histories', data, 'GET')
export const products = data => fetch(urlPerfix + '/products', data, 'GET')
export const productShow = data => fetch(urlPerfix + '/products/' + data.id, data, 'GET')

export const assignTask = data => fetch(urlPerfix + '/task/assign', data, 'POST')
export const undoneTasks = data => fetch(urlPerfix + '/task/undone', data, 'GET')
export const startTask = data => fetch(urlPerfix + '/task/start/' + data.id, data, 'POST')
export const doneTask = data => fetch(urlPerfix + '/task/done', data, 'POST')
export const checkTask = data => fetch(urlPerfix + '/task/check', data, 'POST')

export const formDetail = data => fetch(urlPerfix + '/form/' + data.id, {}, 'GET')

export const newRole = data => fetch(urlPerfix + '/role/roles', data, 'POST')
export const updateRole = data => fetch(urlPerfix + '/role/roles', data, 'PUT')
export const deleteRole = data => fetch(urlPerfix + '/role/roles/' + data.id, {}, 'DELETE')
export const updateUserRole = data => fetch(urlPerfix + '/role/set', data, 'POST')

export const manhourStatistics = data => fetch(urlPerfix + '/statistics/manhour', data, 'POST')
export const manhourDetailStatistics = data => fetch(urlPerfix + '/statistics/manhour/detail', data, 'POST')

export const flowNodes = () => fetch(urlPerfix + '/flow/nodes')

export const processList = () => fetch(urlPerfix + '/process')
export const processCreate = data => fetch(urlPerfix + '/process', data, "POST")



// 日报系统 ============

export const reportStatistics = data => fetch(urlPerfix + '/report/statistics', data, "GET")

// 项目
export const projectList = data => fetch(urlPerfix + '/projects', data)
export const projectNew = data => fetch(urlPerfix + '/projects', data, "POST")
export const projectUpdate = data => fetch(urlPerfix + '/projects/' + data.id, data, "PUT")
export const projectArchive = id => fetch(urlPerfix + '/projects/' + id + '/archive', {}, "POST")
export const projectDetail = id => fetch(urlPerfix + '/projects/' + id)
export const projectDelete = id => fetch(urlPerfix + '/projects/' + id, {}, "DELETE")

// 钻头
// export const drillList = data => fetch(urlPerfix + '/drills', data)
export const drillNew = data => fetch(urlPerfix + '/drills', data, "POST")
export const drillUpdate = data => fetch(urlPerfix + '/drills/' + data.id, data, "PUT")
// export const drillDetail = id => fetch(urlPerfix + '/drills/' + id)
export const drillDelete = id => fetch(urlPerfix + '/drills/' + id, {}, "DELETE")

// 钻头趟数
export const drillTripList = data => fetch(urlPerfix + '/drill_trips', data)
export const drillTripDetail = id => fetch(urlPerfix + '/drill_trips/' + id)

// 日报
export const reportList = data => fetch(urlPerfix + '/reports', data)
export const reportNew = data => fetch(urlPerfix + '/reports', data, "POST")
export const reportUpdate = data => fetch(urlPerfix + '/reports/' + data.id, data, "PUT")
export const reportDetail = id => fetch(urlPerfix + '/reports/' + id)
export const reportDelete = id => fetch(urlPerfix + '/reports/' + id, {}, "DELETE")

// 实验
export const experimentList = data => fetch(urlPerfix + '/experiments', data)
export const experimentNew = data => fetch(urlPerfix + '/experiments', data, "POST")
export const experimentUpdate = data => fetch(urlPerfix + '/experiments/' + data.id, data, "PUT")
export const experimentDetail = id => fetch(urlPerfix + '/experiments/' + id)
export const experimentDelete = id => fetch(urlPerfix + '/experiments/' + id, {}, "DELETE")

// 日报人员
export const reportUserList = data => fetch(urlPerfix + '/report_users', data)
// export const reportUserNew = data => fetch(urlPerfix + '/report_users', data, "POST")
export const reportUserUpdate = data => fetch(urlPerfix + '/report_users/' + data.id, data, "PUT")
export const reportUserDetail = id => fetch(urlPerfix + '/report_users/' + id)
// export const reportUserDelete = id => fetch(urlPerfix + '/report_users/' + id, data, "DELETE")

// 区域
export const regionList = data => fetch(urlPerfix + '/regions', data)
export const regionNew = data => fetch(urlPerfix + '/regions', data, "POST")
export const regionUpdate = data => fetch(urlPerfix + '/regions/' + data.id, data, "PUT")

// 日报系统 ============



//采购模块 ============start==========

//材料
export const commodityList = data => fetch(urlPerfix + '/commodities', data)
export const commodityNew = data => fetch(urlPerfix + '/commodities', data, "POST")
export const commodityUpdate = data => fetch(urlPerfix + '/commodities/' + data.id, data, "PUT")
export const commoditySwitchStatus = id => fetch(urlPerfix + '/commodities/' + id + "/status", {}, "POST")
export const commodityDelete = id => fetch(urlPerfix + '/commodities/' + id, {}, "DELETE")

// 采购单
export const purchaseOrderList = data => fetch(urlPerfix + '/purchase_orders', data)
export const purchaseOrderNew = data => fetch(urlPerfix + '/purchase_orders', data, "POST")
export const purchaseOrderUpdate = data => fetch(urlPerfix + '/purchase_orders/' + data.id, data, "PUT")
export const purchaseOrderDetail = id => fetch(urlPerfix + '/purchase_orders/' + id)
export const purchaseOrderDelete = id => fetch(urlPerfix + '/purchase_orders/' + id, {}, "DELETE")
export const purchaseOrderUpdateStatus = data => fetch(urlPerfix + '/purchase_orders/' + data.id + '/status', data, "POST")


export const purchaseOrderItemList = data => fetch(urlPerfix + '/purchase_order_items', data)
export const purchaseOrderItemUpdate = data => fetch(urlPerfix + '/purchase_order_items/' + data.id, data, "PUT")
export const purchaseOrderItemDelete = id => fetch(urlPerfix + '/purchase_order_items/' + id, {}, "DELETE")
export const purchaseOrderItemConfirm = id => fetch(urlPerfix + '/purchase_order_items/' + id + '/confirm', {}, "POST")

//采购模块 ============end==========


// 销售模块
export const saleOrderList = data => fetch(urlPerfix + '/sale_orders', data)
export const saleOrderNew = data => fetch(urlPerfix + '/sale_orders', data, "POST")
export const saleOrderUpdate = data => fetch(urlPerfix + '/sale_orders/' + data.id, data, "PUT")
export const saleOrderDetail = id => fetch(urlPerfix + '/sale_orders/' + id)
export const saleOrderDelete = id => fetch(urlPerfix + '/sale_orders/' + id, {}, "DELETE")
export const saleOrderUpdateStatus = data => fetch(urlPerfix + '/sale_orders/' + data.id + '/status', data, "POST")